var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.task.reviewType === 'DRAW')?_c('ReviewDrawingTaskCard',{attrs:{"task":_vm.task}}):(_vm.task.reviewType === 'TEMPLATING' || _vm.task.reviewType === 'REVIEW')?_c('ReviewTemplatingTaskCard',{attrs:{"task":_vm.task}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }